import React, { useRef, useEffect, useCallback, useState} from 'react';
import {WIDTH, HEIGHT, PADDING} from './constants.js';
import {connect} from 'react-redux';
import {smoke} from './gl/smoke.js';
import {drawMacros} from './gl/macros.js';
import {setupMacroShaders, setupSmokeShaders} from './gl/setup.js';

let c=0;

const ShaderCanvas = (props) => { 
    let ref = useRef(undefined);
    let ctxt = useRef(undefined);
    let smokeProgram = useRef(undefined);
    let macroProgram = useRef(undefined);
    let ptBuffer = useRef(undefined);
    let colorBuffer = useRef(undefined);

    useEffect(() => {
        ctxt.current = ref.current.getContext('webgl',{preserveDrawingBuffer: true});
        let gl = ctxt.current;
        smokeProgram.current = setupSmokeShaders(gl);
        macroProgram.current = setupMacroShaders(gl);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        gl.clearColor(0, 0, 0, 0);
    }, []);

    useEffect(() => {
        draw();
    }, [props.coords]);

    const draw = useCallback(() => {
        let gl = ctxt.current;
        if (!gl || !smokeProgram.current) {
            return;
        }

        gl.clear(gl.COLOR_BUFFER_BIT);
        // drawMacros(gl, macroProgram.current, props.effect.macros);
        if (props.effect.D) {
            gl.useProgram(smokeProgram.current);
            
            var n = smoke(
                gl,
                smokeProgram.current,
                ref.current,
                props.effect.D,
                props.effect,
                ptBuffer, colorBuffer);
            
            gl.drawArrays(gl.POINTS, 0, n);
        }
    }, []);

    return (
        <canvas style={{width: WIDTH, height: HEIGHT}} width={WIDTH} height={HEIGHT} className="canvas-shader" ref={ref}>
        </canvas>);
};

const mapStateToProps = (state, props) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShaderCanvas);
